export default function HowTrainingGoes() {
  const steps = [
    { num: '01', icon: 'ri-file-search-line', title: 'Предварительный аудит', desc: 'Анализ текущей ситуации в компании: интервью с собственником и ключевыми руководителями, изучение бизнес-процессов, выявление проблемных зон в управлении.' },
    { num: '02', icon: 'ri-chat-1-line', title: 'Интервью с руководителями', desc: 'Индивидуальные беседы с каждым участником: понимание текущих вызовов, уровня компетенций, ожиданий от обучения.' },
    { num: '03', icon: 'ri-file-edit-line', title: 'Подготовка программы', desc: 'Разработка индивидуальной программы с учётом специфики бизнеса, выявленных зон развития и стратегических целей компании.' },
    { num: '04', icon: 'ri-presentation-line', title: 'Проведение тренинга', desc: 'Интенсивное обучение: 80% практики, реальные управленческие кейсы компании, отработка инструментов в безопасной среде.' },
    { num: '05', icon: 'ri-tools-fill', title: 'Практика и домашние задания', desc: 'Закрепление навыков между модулями: внедрение инструментов в ежедневную работу, выполнение практических заданий.' },
    { num: '06', icon: 'ri-feedback-line', title: 'Обратная связь', desc: 'Разбор выполненных заданий, корректировка подходов, индивидуальные рекомендации каждому руководителю.' },
    { num: '07', icon: 'ri-heart-pulse-line', title: 'Сопровождение', desc: 'Посттренинговые коучинговые сессии, поддержка при внедрении изменений, разбор сложных ситуаций в реальном времени.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как проходит обучение руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Прозрачный процесс от первой встречи до устойчивых изменений в управленческой практике
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.slice(0, 4).map((step, i) => (
            <div key={i} className="relative bg-white rounded-xl p-6 hover:ring-2 hover:ring-teal-200 transition-all group">
              <div className="text-5xl font-extrabold text-teal-600/10 absolute top-4 right-5 leading-none">{step.num}</div>
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform relative z-10">
                <i className={`${step.icon} text-lg text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm relative z-10">{step.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed relative z-10">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-5 max-w-4xl mx-auto">
          {steps.slice(4).map((step, i) => (
            <div key={i + 4} className="relative bg-white rounded-xl p-6 hover:ring-2 hover:ring-teal-200 transition-all group">
              <div className="text-5xl font-extrabold text-teal-600/10 absolute top-4 right-5 leading-none">{step.num}</div>
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform relative z-10">
                <i className={`${step.icon} text-lg text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm relative z-10">{step.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed relative z-10">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}